import React from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import CertFlowImg from '../../assets/svg/certFlow.svg'
import { Icon, Input, Button, Menu, Dropdown, Badge } from 'antd'
import sectigoImg from '../../assets/svg/sectigo.svg'
import letsenryptImg from '../../assets/svg/letsencrypt.svg'
import i18n from '../../i18n';
import { SUPPORTED_LANGUAGES } from '../../i18n';
import Logo from '../../components/Logo'

class Default extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      domain: '',
      email: '',
      lang: i18n.language || 'zh'
    }
    document.documentElement.lang = this.state.lang;
  }

  componentDidMount() {
    if (window) {
      window.onkeypress = (e) => {
        if (e.keyCode === 13) {
          e.preventDefault()
          e.stopPropagation()
          this.handleClickSignup()
        }
      }
    }
  }

  componentWillUnmount() {
    if (window) {
      window.onkeypress = null
    }
  }

  handleClickSignin = () => {
    this.props.history.push('/signin')
  }

  handleClickSignup = () => {
    const { domain, email } = this.state

    const params = []
    if (domain) {
      params.push(`domain=${encodeURIComponent(domain)}`)
    }
    if (email) {
      params.push(`email=${encodeURIComponent(email)}`)
    }

    if (params.length) {
      this.props.history.push(`/signup?${params.join('&')}`)
      return
    }
    this.props.history.push('/signup')
  }

  handleClickSubscribe = (subscribeId) => {
    this.props.history.push(`/signup?subscribeId=${subscribeId}`)
  }

  handleClickConnect = () => {
    this.props.history.push('/signup')
  }

  handleDomainChange = (e) => {
    this.setState({
      domain: e.target.value.trim()
    })
  }

  handleEmailChange = (e) => {
    this.setState({
      email: e.target.value.trim()
    })
  }

  handleLanguageChange = ({key}) => {
    this.setState({ lang: key }, () => {
      i18n.changeLanguage(key)
      document.documentElement.lang = key
    })
  }

  render() {
    const { t } = this.props;
    const langName = SUPPORTED_LANGUAGES.find(item => item.code === this.state.lang).name

    return (
      <div className="default" style={{ background: '#f2f3f4', color: 'black' }}>
        <div className='header' style={{ margin: "auto", display: 'flex', width: 1200, justifyContent: 'space-between', height: "80px", paddingTop: '30px' }}>
          <div className='left' style={{ display: 'flex', alignItems: "center" }}>
            <Logo />
          </div>
          <div className='right' style={{ display: 'flex', alignItems: "center" }}>
            <Button type="link" style={{ color: "black" }} href='#feature'>{t('header.features')}</Button>
            <Button type="link" style={{ color: "black" }} href="/docs/start" target="_blank">{t('header.quickStart')}</Button>
            <Button type="link" style={{ color: "black" }} href="/docs" target="_blank">{t('header.helpDocs')}</Button>
            <div style={{ marginRight: '20px' }}>
              <Dropdown
                overlay={
                  <Menu onClick={this.handleLanguageChange}>
                    {SUPPORTED_LANGUAGES.map(item => <Menu.Item key={item.code}>{item.name}</Menu.Item>)}
                  </Menu>
                }
              >
                <a className="ant-dropdown-link" href="/" target="_blank" onClick={e => e.preventDefault()} style={{ width: 110, display: "flex", justifyContent: 'space-between', alignItems: "center", color: "black" }}>
                  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill='black'>
                    <path d="M200.896 626.688v199.488c0 4.928 3.584 8.96 8.256 9.856l1.792 0.128h201.728V896H211.008c-37.504 0-68.48-28.992-70.528-65.984l-0.064-3.84V626.688h60.48zM816 437.12V237.632a9.984 9.984 0 0 0-8.256-9.792l-1.792-0.192H604.16v-59.84h201.728c37.44 0 68.416 28.992 70.464 65.984l0.128 3.84v199.552h-60.544zM357.76 128v95.424h178.24v225.664H357.76V604.16h-52.48V449.088H128V223.36h177.28V128h52.416zM179.392 273.728V399.36h125.824V273.728H179.392z m178.304 0V399.36H484.48V273.728H357.76zM896 888.64h-62.912l-42.496-119.808h-145.28l-42.432 119.808h-62.912l147.328-400.96h61.376L896 888.64z m-179.84-319.552l-50.88 144.192h105.408l-51.392-144.192h-3.2 0.064z"></path>
                  </svg>
                  {langName}
                  <Icon type="down" />
                </a>
              </Dropdown>
            </div>
            
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: 'center' }}>
              <Button style={{ borderColor: "transparent", background: "rgba(0,0,0,.075)", color: "black" }} onClick={this.handleClickSignin} >{t('header.login')}</Button>
              <Button type="primary" style={{ marginLeft: '15px' }} onClick={this.handleClickSignup}>{t('header.register')}</Button>
            </div>
          </div>
        </div>
        <div className='apply' style={{ width: 1200, margin: '25px auto 35px', display: 'flex', flexDirection: "column", padding: "30px 20px", color: "white", background: "#1c2035", boxShadow: 'rgba(0, 0, 0, 0.1) 1px 1px 4px 0px, rgba(0, 0, 0, 0.2) 2px 2px 16px 0px' }}>
          <div style={{ fontSize: "18px", marginBottom: "15px" }}>{t('apply.title')}</div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
              <div style={{ background: "#f2f3f4", height: 50, paddingLeft: '15px', display: "flex", justifyContent: "center", alignItems: "center", color: "black" }}>
                <img src="https://ssl.cdn.idevbase.com/assets/images/https.svg" alt='https' height={20} />&nbsp;
                <span>HTTPS</span>
              </div>
              <Input style={{ border: 'none', background: "#f2f3f4", width: 920, height: 50 }} value={this.state.domain} onChange={this.handleDomainChange} placeholder={t('apply.inputDomain')} />
            </div>
            <Button type="primary" style={{ width: 140, height: 50 }} onClick={this.handleClickSignup}>{t('apply.applyFreeCert')}</Button>
          </div>
        </div>
        <div className='content' style={{ width: 1200, margin: '0px auto', display: 'flex', justifyContent: 'space-between', flexDirection: "column" }}>
          <div style={{ width: "100%", display: "flex" }}>
            <div style={{ width: "50%", display: 'flex', flexDirection: "column", justifyContent: "space-between" }}>
              <p style={{ fontSize: "16px", fontWeight: 600 }}>
                <img src="https://ssl.cdn.idevbase.com/assets/images/lighting.svg" alt='lighting' height={20} />
                <span>{t('intro.quickTitle')}</span>
              </p>
              <p style={{ fontSize: "32px", width: "550px", color: "white" }}>
                <span style={{ background: "#0052d9", padding: '5px 20px', display: 'inline-block' }}>
                  {t('intro.slogan1')}
                </span><br />
                <span style={{ background: "#0052d9", padding: '5px 20px', display: 'inline-block', marginTop: '1px' }}>
                  {t('intro.slogan2')}
                </span><br />
                <span style={{ background: "#0052d9", padding: '5px 20px', display: 'inline-block', marginTop: '1px' }}>
                  {t('intro.slogan3')}
                </span><br />
                <span style={{ background: "#0052d9", padding: '5px 20px', display: 'inline-block', marginTop: '1px' }}>
                  {t('intro.slogan4')}
                </span>
              </p>
              <p style={{ fontSize: "18px", marginBottom: '0px', width: "500px", fontWeight: 600 }}>
                {t('intro.features')}
              </p>
            </div>
            <div style={{ width: "50%", display: 'flex', justifyContent: "space-between" }}>
              <div style={{ background: "rgb(234, 249, 255)", boxShadow: 'rgba(0, 0, 0, 0.1) 1px 1px 4px 0px, rgba(0, 0, 0, 0.2) 2px 2px 16px 0px', width: 180, height: 350 }}>
                <div style={{ background: "white", padding: '15px', height: 185 }}>
                  <div style={{ display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "flex-end" }}>
                    <div style={{ fontSize: "48px", marginRight: '10px', fontWeight: "bold", color: "rgba(0, 0, 0, 0.50)" }}>1</div>
                    <p style={{ fontWeight: "bolder" }}>{t('steps.step1.title')}</p>
                  </div>
                  <div>
                    <div style={{ color: "rgba(0, 0, 0, 0.50)", fontWeight: "bolder" }}><span style={{ color: "rgba(0, 0, 0, 0.65)" }}><Badge className="dot" color="rgba(0, 0, 0, 0.65)"/></span>&nbsp;{t('steps.step1.line1')}</div>
                    <div style={{ color: "rgba(0, 0, 0, 0.50)", fontWeight: "bolder" }}><span style={{ color: "rgba(0, 0, 0, 0.65)" }}><Badge className="dot" color="rgba(0, 0, 0, 0.65)"/></span>&nbsp;{t('steps.step1.line2')}</div>
                    <div style={{ color: "rgba(0, 0, 0, 0.50)", fontWeight: "bolder" }}><span style={{ color: "rgba(0, 0, 0, 0.65)" }}><Badge className="dot" color="rgba(0, 0, 0, 0.65)"/></span>&nbsp;{t('steps.step1.line3')}</div>
                    <div style={{ color: "rgba(0, 0, 0, 0.50)", fontWeight: "bolder" }}><span style={{ color: "rgba(0, 0, 0, 0.65)" }}><Badge className="dot" color="rgba(0, 0, 0, 0.65)"/></span>&nbsp;{t('steps.step1.line4')}</div>
                  </div>
                </div>
                <div style={{ padding: '15px', height: 150 }}>
                  <div style={{ fontWeight: "bolder" }}>
                    <Badge className="dot" color="green" status="processing"/>&nbsp;
                    <Badge className="dot" color="red"/>&nbsp;
                    <Badge className="dot" color="red"/>&nbsp;
                  </div>
                  <img style={{ display: 'block', margin: "18px auto" }} src="https://ssl.cdn.idevbase.com/assets/images/domain.svg" alt='domain' height="60" />
                </div>
              </div>
              <div style={{ background: "rgb(234, 249, 255)", boxShadow: 'rgba(0, 0, 0, 0.1) 1px 1px 4px 0px, rgba(0, 0, 0, 0.2) 2px 2px 16px 0px', width: 180, height: 350 }}>
                <div style={{ background: "white", padding: '15px', height: 185 }}>
                  <div style={{ display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "flex-end" }}>
                    <div style={{ fontSize: "48px", marginRight: '10px', fontWeight: "bold", color: "rgba(0, 0, 0, 0.50)" }}>2</div>
                    <p style={{ fontWeight: "bolder" }}>{t('steps.step2.title')}</p>
                  </div>
                  <div>
                    <div style={{ color: "rgba(0, 0, 0, 0.50)", fontWeight: "bolder" }}><span style={{ color: "rgba(0, 0, 0, 0.65)" }}><Badge className="dot" color="rgba(0, 0, 0, 0.65)"/></span>&nbsp;{t('steps.step2.line1')}</div>
                    <div style={{ color: "rgba(0, 0, 0, 0.50)", fontWeight: "bolder" }}><span style={{ color: "rgba(0, 0, 0, 0.65)" }}><Badge className="dot" color="rgba(0, 0, 0, 0.65)"/></span>&nbsp;{t('steps.step2.line2')}</div>
                    <div style={{ color: "rgba(0, 0, 0, 0.50)", fontWeight: "bolder" }}><span style={{ color: "rgba(0, 0, 0, 0.65)" }}><Badge className="dot" color="rgba(0, 0, 0, 0.65)"/></span>&nbsp;{t('steps.step2.line3')}</div>
                  </div>
                </div>
                <div style={{ padding: '15px', height: 150 }}>
                  <div style={{ fontWeight: "bolder" }}>
                    <Badge className="dot" color="green" status="processing"/>&nbsp;
                    <Badge className="dot" color="green" status="processing"/>&nbsp;
                    <Badge className="dot" color="red"/>&nbsp;
                  </div>
                  <img style={{ display: 'block', margin: "10px auto" }} src="https://ssl.cdn.idevbase.com/assets/images/dns.svg" alt='dns' height="80" />
                </div>
              </div>
              <div style={{ background: "rgb(234, 249, 255)", boxShadow: 'rgba(0, 0, 0, 0.1) 1px 1px 4px 0px, rgba(0, 0, 0, 0.2) 2px 2px 16px 0px', width: 180, height: 350 }}>
                <div style={{ background: "white", padding: '15px', height: 185 }}>
                  <div style={{ display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "flex-end" }}>
                    <div style={{ fontSize: "48px", marginRight: '10px', fontWeight: "bold", color: "rgba(0, 0, 0, 0.50)" }}>3</div>
                    <p style={{ fontWeight: "bolder" }}>{t('steps.step3.title')}</p>
                  </div>
                  <div>
                    <div style={{ color: "rgba(0, 0, 0, 0.50)", fontWeight: "bolder" }}><span style={{ color: "rgba(0, 0, 0, 0.65)" }}><Badge className="dot" color="rgba(0, 0, 0, 0.65)"/></span>&nbsp;{t('steps.step3.line1')}</div>
                    <div style={{ color: "rgba(0, 0, 0, 0.50)", fontWeight: "bolder" }}><span style={{ color: "rgba(0, 0, 0, 0.65)" }}><Badge className="dot" color="rgba(0, 0, 0, 0.65)"/></span>&nbsp;{t('steps.step3.line2')}</div>
                    <div style={{ color: "rgba(0, 0, 0, 0.50)", fontWeight: "bolder" }}><span style={{ color: "rgba(0, 0, 0, 0.65)" }}><Badge className="dot" color="rgba(0, 0, 0, 0.65)"/></span>&nbsp;{t('steps.step3.line3')}</div>
                  </div>
                </div>
                <div style={{ padding: '15px', height: 150 }}>
                  <div style={{ fontWeight: "bolder" }}>
                    <Badge className="dot" color="green" status="processing"/>&nbsp;
                    <Badge className="dot" color="green" status="processing"/>&nbsp;
                    <Badge className="dot" color="green" status="processing"/>&nbsp;
                  </div>
                  <img style={{ display: 'block', margin: "18px auto" }} src="https://ssl.cdn.idevbase.com/assets/images/cert.svg" alt='cert' height="60" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='certificate' style={{ width: 1200, margin: '35px auto', display: 'flex', justifyContent: 'space-between', flexDirection: "column", alignItems: "center", boxShadow: 'rgba(0, 0, 0, 0.1) 1px 1px 4px 0px, rgba(0, 0, 0, 0.2) 2px 2px 16px 0px' }}>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ width: '50%', background: 'rgba(255, 255, 255, 0.5)', padding: '30px 40px', height: '300px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div style={{ color: 'rgb(39, 53, 94)' }}>
                <div style={{ fontSize: '18px', fontWeight: '600', height: 50, display: 'flex', alignItems: 'center' }}>
                  <img height={50} style={{ transform: 'translateY(-10px)', marginRight: '12px' }} src={letsenryptImg} alt="Let's Encrypt" /> - {t('certificate.free.title')}
                </div>
                <div style={{ letterSpacing: '0.15rem', marginTop: '8px', color: 'rgba(39, 53, 94, 0.8)' }}>{t('certificate.free.description')}</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: 'rgba(39, 53, 94, 1)', marginTop: '15px', height: 110, justifyContent: 'space-between' }}>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', height: 30 }}>
                  <div>{t('certificate.free.singleDomain')}<span style={{ fontSize: '12px' }}>·{t('certificate.free.validity')}</span></div>
                  <div style={{ fontSize: '14px', fontWeight: '600' }}>{t('certificate.free.price')}</div>
                </div>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', height: 30 }}>
                  <div>{t('certificate.free.multiDomain')}<span style={{ fontSize: '12px' }}>·{t('certificate.free.validity')}</span></div>
                  <div style={{ fontSize: '14px', fontWeight: '600' }}>{t('certificate.free.price')}</div>
                </div>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', height: 30 }}>
                  <div>{t('certificate.free.wildcardDomain')}<span style={{ fontSize: '12px' }}>·{t('certificate.free.validity')}</span></div>
                  <div style={{ fontSize: '14px', fontWeight: '600' }}>{t('certificate.free.price')}</div>
                </div>
              </div>
            </div>
            <div style={{ width: '50%', background: 'rgb(88, 99, 130)', padding: '30px 40px', height: '300px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div style={{ color: 'white' }}>
                <div style={{ fontSize: '18px', fontWeight: '600', height: 50, display: 'flex', alignItems: 'center' }}>
                <img height={28} style={{ marginRight: '8px' }} src={sectigoImg} alt="Sectigo" /> - {t('certificate.pro.title')}
                </div>
                <div style={{ letterSpacing: '0.15rem', marginTop: '8px', color: 'rgba(255, 255, 255, 0.8)' }}>{t('certificate.pro.description')}</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: 'white', marginTop: '15px', height: 110, justifyContent: 'space-between' }}>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', height: 30 }}>
                  <div>{t('certificate.pro.singleDomain')}<span style={{ fontSize: '12px' }}>·{t('certificate.pro.validity')}</span></div>
                  <div style={{ fontSize: '12px' }}><span style={{ fontSize: '18px', fontWeight: '600' }}>{t('certificate.pro.priceOfSingleDomain')}</span>{t('certificate.pro.priceUnitOfSingleDomain')}</div>
                </div>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', height: 30 }}>
                  <div>{t('certificate.pro.multiDomain')}<span style={{ fontSize: '12px' }}>·{t('certificate.pro.validity')}</span></div>
                  <div style={{ fontSize: '12px' }}><span style={{ fontSize: '18px', fontWeight: '600' }}>{t('certificate.pro.priceOfMultiDomain')}</span>{t('certificate.pro.priceUnitOfMultiDomain')}</div>
                </div>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', height: 30 }}>
                  <div>{t('certificate.pro.wildcardDomain')}<span style={{ fontSize: '12px' }}>·{t('certificate.pro.validity')}</span></div>
                  <div style={{ fontSize: '12px' }}><span style={{ fontSize: '18px', fontWeight: '600' }}>{t('certificate.pro.priceOfWildcardDomain')}</span>{t('certificate.pro.priceUnitOfWildcardDomain')}</div>
                </div>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', height: 30 }}>
                  <div>{t('certificate.pro.ipCert')}<span style={{ fontSize: '12px' }}>·{t('certificate.pro.validity')}</span></div>
                  <div style={{ fontSize: '12px' }}><span style={{ fontSize: '18px', fontWeight: '600' }}>{t('certificate.pro.priceOfIpCert')}</span>{t('certificate.pro.priceUnitOfIpCert')}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='content' style={{ width: 1200, margin: '35px auto', display: 'flex', justifyContent: 'space-between', flexDirection: "column", alignItems: "center" }}>
          <div style={{ fontSize: "24px", fontWeight: "600", color: "black", marginBottom: '12px' }}>{t('deployment.title')}</div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: '100%' }}>
            <a href='/docs/cloud/aliyun/' target='_blank'><img height="26" src="https://ssl.cdn.idevbase.com/assets/logo/ohttps_aliyun_with_name.svg" alt='阿里云' /></a>
            <a href='/docs/cloud/tcloud/' target='_blank'><img height="28" src="https://ssl.cdn.idevbase.com/assets/logo/ohttps_tcloud_with_name.svg" alt='腾讯云' /></a>
            <a href='/docs/cloud/huawei/' target='_blank'><img height="40" src="https://ssl.cdn.idevbase.com/assets/logo/ohttps_huawei_with_name.svg" alt='华为云' /></a>
            <a href='/docs/cloud/bcloud/' target='_blank'><img height="34" src="https://ssl.cdn.idevbase.com/assets/logo/ohttps_bcloud_with_name.svg" alt='百度智能云' /></a>
            <a href='/docs/cloud/btcn/' target='_blank'><img height="32" src="https://ssl.cdn.idevbase.com/assets/logo/ohttps_btcn_with_name.svg" alt='宝塔面板' /></a>
            <a href='/docs/cloud/1panel/' target='_blank'><img height="32" src="https://ssl.cdn.idevbase.com/assets/logo/ohttps_1panle_with_name.png" alt='1Panel面板' /></a>
            <a href='/docs/cloud/qiniu/' target='_blank'><img height="28" src="https://ssl.cdn.idevbase.com/assets/logo/ohttps_qiniu_with_name.svg" alt='七牛云' /></a>
            <a href='/docs/cloud/upyun/' target='_blank'><img height="32" src="https://ssl.cdn.idevbase.com/assets/logo/ohttps_upyun_with_name.png" alt='又拍云' /></a>
            <a href='/docs/cloud/doge/' target='_blank'><img height="28" src="https://ssl.cdn.idevbase.com/assets/logo/ohttps_doge_with_name.png" alt='多吉云' /></a>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: '920px', marginTop: '8px' }}>
            <a href='/docs/cloud/synology/' target='_blank' style={{fontSize: '20px', color: 'black', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center'}}><img height="28" src="https://ssl.cdn.idevbase.com/assets/logo/ohttps_synology_with_name.png" alt='群晖NAS' /><span style={{marginLeft: '0px'}}>{t('deployment.synology')}</span></a>
            <a href='/docs/cloud/docker/' target='_blank'><img height="34" src="https://ssl.cdn.idevbase.com/assets/logo/ohttps_docker_with_name.svg" alt='Docker容器' style={{ margin: '0 -20px 0 -15px' }} /></a>
            <a href='/docs/cloud/docker/nginx/' target='_blank'><img height="25" src="https://ssl.cdn.idevbase.com/assets/logo/ohttps_nginx_with_name.svg" alt='NGINX' /></a>
            <a href='/docs/cloud/docker/openresty/' target='_blank'><img height="48" src="https://ssl.cdn.idevbase.com/assets/logo/ohttps_openresty_with_name.png" alt='OpenResty' style={{transform: 'translateY(-6px)'}}/></a>
            <a href='/docs/cloud/webhook/' target='_blank' style={{fontSize: '20px', color: 'rgb(48, 62, 70)', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center'}}><img height="40" src="https://ssl.cdn.idevbase.com/assets/logo/ohttps_webhook.png" alt='WEBHOOK' /><span style={{marginLeft: '-2px'}}>{t('deployment.webhook')}</span></a>
            <a href='/docs/cloud/ssh/' target='_blank' style={{fontSize: '20px', color: 'black', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center'}}><img height="36" src="https://ssl.cdn.idevbase.com/assets/logo/ohttps_ssh.png" alt='SSH远程命令' /><span style={{marginLeft: '3px'}}>{t('deployment.ssh')}</span></a>
            <a href='/docs/cloud/api/' target='_blank' style={{fontSize: '20px', color: 'black', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center'}}><img height="40" src="https://ssl.cdn.idevbase.com/assets/logo/ohttps_api.png" alt='API接口' /><span style={{marginLeft: '2px'}}>{t('deployment.api')}</span></a>
          </div>
        </div>
        <div id="feature" style={{ background: "white" }}>
          <div className='content' style={{ width: 1200, margin: '0px auto', display: 'flex', justifyContent: 'space-between', flexDirection: "column", padding: "35px 0" }}>
            <div style={{ display: 'flex', flexDirection: "row", justifyContent: "space-between" }}>
              <div style={{ width: 260 }}>
                <div style={{ height: 60, width: 60, display: 'flex', justifyContent: 'center' }}>
                  <img src="https://ssl.cdn.idevbase.com/assets/images/org.svg" alt="Let's Encrypt" height='60' />
                </div>
                <div style={{ fontSize: '16px', fontWeight: 'bold', margin: "8px 0" }}>
                  {t('features.topProvider.title')}
                </div>
                <div style={{ color: "rgba(0, 0, 0, 0.8)" }}>
                  {t('features.topProvider.description1')}<a href="https://letsencrypt.org/" target='_blank' rel="noopener noreferrer" style={{ fontWeight: 600 }}>{t('features.topProvider.description2')}</a>&nbsp;{t('features.topProvider.description3')} &nbsp;<a href="https://www.sectigo.com/" target='_blank' rel="noopener noreferrer" style={{ fontWeight: 600 }}>{t('features.topProvider.description4')}</a>&nbsp;{t('features.topProvider.description5')}<strong style={{ color: 'black' }}>{t('features.topProvider.description6')}</strong>{t('features.topProvider.description7')}
                </div>
              </div>
              <div style={{ width: 260 }}>
                <div style={{ height: 60, width: 60, display: 'flex', justifyContent: 'center' }}>
                  <img src="https://ssl.cdn.idevbase.com/assets/images/https.svg" alt='https' height='53' />
                </div>

                <div style={{ fontSize: '16px', fontWeight: 'bold', margin: "8px 0" }}>
                  {t('features.browserSupport.title')}
                </div>
                <div style={{ color: "rgba(0, 0, 0, 0.8)" }}>
                  {t('features.browserSupport.description1')}<strong style={{ color: 'black' }}>99.99%</strong>{t('features.browserSupport.description2')}
                </div>
              </div>
              <div style={{ width: 260 }}>
                <div style={{ height: 60, width: 60, display: 'flex', justifyContent: 'center' }}>
                  <img src="https://ssl.cdn.idevbase.com/assets/images/auto.svg" alt='auto' height='51' />
                </div>
                <div style={{ fontSize: '16px', fontWeight: 'bold', margin: "8px 0" }}>
                  {t('features.autoUpdate.title')}
                </div>
                <div style={{ color: "rgba(0, 0, 0, 0.8)" }}>
                  {t('features.autoUpdate.description')}
                </div>
              </div>
              <div style={{ width: 260 }}>
                <div style={{ height: 60, width: 60, display: 'flex', justifyContent: 'center' }}>
                  <img src="https://ssl.cdn.idevbase.com/assets/images/watch.svg" alt='watch' height='55' />
                </div>
                <div style={{ fontSize: '16px', fontWeight: 'bold', margin: "8px 0" }}>
                  {t('features.monitoring.title')}
                </div>
                <div style={{ color: "rgba(0, 0, 0, 0.8)" }}>
                  {t('features.monitoring.description')}
                </div>
              </div>
            </div>
            <div style={{ marginTop: "35px", display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
              <div style={{ display: 'flex', flexDirection: 'column', width: '50%', paddingRight: "30px", justifyContent: "space-around" }}>
                <div>
                  <span style={{ background: '#586382', fontSize: "19px", fontWeight: "bold", padding: "10px", lineHeight: "30px", color: "white", display: 'inline-block' }}>
                    {t('features.management.slogan1')}
                  </span>
                  <br />
                  <span style={{ background: '#586382', fontSize: "19px", fontWeight: "bold", padding: "10px", lineHeight: "30px", color: "white", display: 'inline-block', marginTop: '1px' }}>
                    {t('features.management.slogan2')}
                  </span>
                </div>
                <div style={{ display: 'flex', flexDirection: "row", color: "rgba(0, 0, 0, 0.8)" }}>
                  <div style={{ display: 'flex', flexDirection: "column", justifyContent: "space-between", height: 150 }}>
                    <div style={{ fontWeight: "bold" }}>
                      <Icon type="check-circle" theme="filled" />&nbsp;{t('features.certTypes.singleDomain')}</div>
                    <div style={{ fontWeight: "bold" }}>
                      <Icon type="check-circle" theme="filled" />&nbsp;{t('features.certTypes.multiDomain')}</div>
                    <div style={{ fontWeight: "bold" }}>
                      <Icon type="check-circle" theme="filled" />&nbsp;{t('features.certTypes.wildcardDomain')}</div>
                    <div style={{ fontWeight: "bold" }}>
                      <Icon type="check-circle" theme="filled" />&nbsp;{t('features.verification.dnsVerification')}</div>
                    <div style={{ fontWeight: "bold" }}>
                      <Icon type="check-circle" theme="filled" />&nbsp;{t('features.verification.cnameVerification')}</div>
                    <div style={{ fontWeight: "bold" }}>
                      <Icon type="check-circle" theme="filled" />&nbsp;{t('features.cert.formatConversion')}</div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: "column", justifyContent: "space-between", marginLeft: "60px", height: 150 }}>
                    <div style={{ fontWeight: "bold" }}>
                      <Icon type="check-circle" theme="filled" />&nbsp;{t('features.auto.autoUpdate')}</div>
                    <div style={{ fontWeight: "bold" }}>
                      <Icon type="check-circle" theme="filled" />&nbsp;{t('features.auto.autoDeploy')}</div>
                    <div style={{ fontWeight: "bold" }}>
                      <Icon type="check-circle" theme="filled" />&nbsp;{t('features.auto.autoMonitor')}</div>
                    <div style={{ fontWeight: "bold" }}>
                      <Icon type="check-circle" theme="filled" />&nbsp;{t('features.auto.autoAlert')}</div>
                    <div style={{ fontWeight: "bold" }}>
                      <Icon type="check-circle" theme="filled" />&nbsp;{t('features.deploy.multipleDeployTypes')}</div>
                    <div style={{ fontWeight: "bold" }}>
                      <Icon type="check-circle" theme="filled" />&nbsp;{t('features.alert.multipleAlertMethods')}</div>
                  </div>
                </div>
              </div>
              <div style={{ width: "50%" }}>
                <object type="image/svg+xml" data={CertFlowImg} aria-labelledby="证书由顶级证书机构颁发"></object>
              </div>
            </div>
          </div>
        </div>
        <div id="stats" style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', background: '#2977FC', textAlign: 'center', position: 'relative', overflow: 'hidden', height: 480, color: 'white' }}>
          <div style={{ display: 'block', position: 'absolute', left: 0, top: 0, opacity: 0.1, background: 'url(https://ssl.cdn.idevbase.com/assets/images/stats.svg)', width: '100%', height: 600, backgroundSize: 250, backgroundPosition: '50%' }}></div>
          <p style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '15px' }}>{t('stats.title')}</p>
          <p style={{ width: 850 }}>{t('stats.description1')}<br />{t('stats.description2')}</p>
          <div style={{ margin: '15px 0px 30px' }}>
            <Button style={{ backgroundColor: 'rgb(28, 32, 53)', borderColor: 'rgb(28, 32, 53)', color: "white", padding: '0 25px', height: 50, boxShadow: 'rgba(0, 0, 0, 0.1) 1px 1px 4px 0px, rgba(0, 0, 0, 0.2) 2px 2px 16px 0px' }} onClick={this.handleClickSignup}>{t('stats.getStarted')}</Button> - {t('stats.freeCert')}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'white', width: 900, color: 'black', padding: '30px 90px 17px', boxShadow: 'rgba(0, 0, 0, 0.1) 1px 1px 4px 0px, rgba(0, 0, 0, 0.2) 2px 2px 16px 0px' }}>
            <div><Icon type="line-chart" style={{ fontSize: '45px' }} /><p style={{ fontSize: '16px', fontWeight: 'bold', margin: '10px 0 0px' }}>10000+</p><p style={{ color: 'rgba(0, 0, 0, 0.8)' }}>{t('stats.monthlyCertCount')}</p></div>
            <div><Icon type="safety" style={{ fontSize: '45px' }} /><p style={{ fontSize: '16px', fontWeight: 'bold', margin: '10px 0 0px' }}>99.99%</p><p style={{ color: 'rgba(0, 0, 0, 0.8)' }}>{t('stats.browserSupport')}</p></div>
            <div><Icon type="cluster" style={{ fontSize: '45px' }} /><p style={{ fontSize: '16px', fontWeight: 'bold', margin: '10px 0 0px' }}>{parseInt((Date.now() - new Date('2019-12-23T00:13:35.000Z').getTime()) / 1000 / 60 / 60 / 24)}{t('stats.days')}</p><p style={{ color: 'rgba(0, 0, 0, 0.8)' }}>{t('stats.serviceUptime')}</p></div>
          </div>
        </div>
        <div className='footer' style={{ background: "rgb(28, 32, 53)", color: 'white' }}>
          <div className='footer' style={{ width: 1200, margin: "auto", display: 'flex', flexDirection: 'column', padding: '30px 0 40px' }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center', borderBottom: "0.5px solid", padding: '10px 0 25px' }}>
              <div style={{ fontSize: "24px", fontWeight: '600' }} className='logo'>OHTTPS</div>
              <div style={{ display: "flex", justifyContent: "flex-end", alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', whiteSpace: "nowrap" }}>{t('register.title')}&nbsp;</div>
                <Input placeholder={t('register.placeholder')} style={{ height: 38, width: 250, border: 'none' }} value={this.state.email} onChange={this.handleEmailChange} />
                <Button style={{ backgroundColor: '#0052d9', borderColor: '#0052d9', color: "white", height: 38 }} onClick={this.handleClickSignup}>{t('register.button')}</Button>
              </div>
            </div>
            <div>
            </div>
            <div style={{ display: "flex", justifyContent: 'space-between', alignItems: 'flex-start', marginTop: '20px' }}>
              <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'flex-start', flexDirection: "row", width: 500 }}>
                <div>
                  <div style={{ fontWeight: "bold", fontSize: "14px", marginBottom: "10px" }}>{t('about.title')}</div>
                  <div>
                    <div><a href='/docs' target='_blank' style={{ color: 'white' }}>{t('about.aboutUs')}</a></div>
                    <div><a href='mailto:service@ohttps.com' target='_blank' rel="noopener noreferrer" style={{ color: 'white' }}>{t('about.contactUs')}</a></div>
                    <div><a href='/docs/price' target='_blank' style={{ color: 'white' }}>{t('about.pricing')}</a></div>
                  </div>
                </div>
                <div>
                  <div style={{ fontWeight: "bold", fontSize: "14px", marginBottom: "10px" }}>{t('solutions.title')}</div>
                  <div>
                    <div>{t('solutions.autoUpdate')}</div>
                    <div style={{ marginTop: '2px' }}>{t('solutions.autoDeploy')}</div>
                    <div style={{ marginTop: '2px' }}>{t('solutions.autoMonitor')}</div>
                  </div>
                </div>
                <div>
                  <div style={{ fontWeight: "bold", fontSize: "14px", marginBottom: "10px" }}>{t('help.title')}</div>
                  <div>
                    <div><a href='/docs/start' target='_blank' style={{ color: 'white' }}>{t('help.quickStart')}</a></div>
                    <div style={{ marginTop: '2px' }}><a href='/docs/dns' target='_blank' style={{ color: 'white' }}>{t('help.dnsAuth')}</a></div>
                    <div style={{ marginTop: '2px' }}><a href='/docs/cloud' target='_blank' style={{ color: 'white' }}>{t('help.deployNodes')}</a></div>
                    <div style={{ marginTop: '2px' }}><a href='/docs/certformat' target='_blank' style={{ color: 'white' }}>{t('help.certFormat')}</a></div>
                    <div style={{ marginTop: '2px' }}><a href='/docs/questions' target='_blank' style={{ color: 'white' }}>{t('help.faq')}</a></div>
                  </div>
                </div>
                <div>
                  <div style={{ fontWeight: "bold", fontSize: "14px", marginBottom: "10px" }}>{t('policy.title')}</div>
                  <div>
                    <div><a href='/docs/terms' target='_blank' style={{ color: 'white' }}>{t('policy.terms')}</a></div>
                    <div style={{ marginTop: '2px' }}><a href='/docs/privacy' target='_blank' style={{ color: 'white' }}>{t('policy.privacy')}</a></div>
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: "column", justifyContent: "space-between", alignItems: "end", height: 144 }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: "center" }}>
                  {t('contact.title')}: 
                  <span style={{ fontSize: "18px", display: 'flex', justifyContent: "space-between", alignItems: "center", marginLeft: '4px' }}>
                    <a href='mailto:service@ohttps.com' target='_blank' rel="noopener noreferrer" style={{ color: 'white' }}><Icon type="mail" theme="filled" /></a>
                  </span>
                </div>
                <div style={{ color: "rgba(200, 200, 200, 0.8)" }}>
                  &copy; 2019-{new Date().getFullYear()} OHTTPS All Rights Reserved.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Default = withTranslation()(connect()(Default))

export default Default
